import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "../../../services/common.service";
import { AppConfig } from "../../../configs/app";
import { PlanService } from "../../../services/plan.service";
import { SiteService } from "../../../services/site.service";
import { CacheService } from "../../../services/cache.service";
import { AnalyticsService } from "../../../services/analytics.service";

declare let Swiper: any; /* Swiper */

@Component({
  selector: "page-home-index",
  templateUrl: "./index.component.html",
})
export class PageHomeIndexComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public searchParams: any = {};
  public filterData: any = {};

  public planList: any = [];
  public viewedPlans: any = {};
  public favouritePlans: any = {};
  public pagination: any = {};
  public activatedStation: any = {};
  public targetDay: string;
  public calendarDate: string;
  public hasTargetDay: boolean;
  public monthJustChanged: boolean;
  public initDate: string; /* AS SELECTED/ACTIVE DATE */
  public city: string;
  public town: string;

  /* NOTIFY LIST */
  public notifyList: any = [];
  public notifyDetail: any = {};

  /* BEST PRICES */
  public bestPriceData: any;

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  /* BUS SETTINGS */
  public busSettings: any = {};

  constructor(
    public ref: ChangeDetectorRef,
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public appConfig: AppConfig,
    public commonService: CommonService,
    public planService: PlanService,
    public siteService: SiteService,
    public cacheService: CacheService,
    private analyticsService: AnalyticsService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();

    /*
            SET INIT DATE
            IF NOW IS GREATER THAN 18, SET INIT DATE TO THE NEXT DAY
        */
    if (this.moment().hour() < 18) {
      this.initDate = this.moment().format("YYYYMMDD");
    } else {
      this.initDate = this.moment().add(1, "days").format("YYYYMMDD");
    }
    /* END */
    this.targetDay = this.initDate;
    this.hasTargetDay = false;
    // 【2026-08-01修正】価格カレンダーの取得起点は「実際の今日」に固定。
    // initDate(18時以降=翌日)起点だと月末日の18時以降に当月データが取得されず
    // 当日が選択不可になるため(詳細はlayout-partial.component.tsの同修正コメント参照)。
    this.calendarDate = this.moment().format("YYYYMMDD");
    this.monthJustChanged = true;

    /* FILTER DATA */
    this.filterData = {
      targetDay: this.targetDay,
      isViewingCalendar: false,
      cityChoosingType: "departure",
      sort: 1,

      bestPriceList: {
        thisMonth: {},
        nextMonth: {},
        next2Month: {},
        next3Month: {},
      },

      divisionData: {},
      townData: {
        departure: {},
        destination: {},
      },

      departureYMD: this.targetDay,
      departureCityID: "",
      destinationCityID: "",
      departureTownID: "",
      destinationTownID: "",

      /* PLAN OPTIONS */
      planOptions: this.planService.getPlanOptions(),
      chosenOptions: {},
      tempChosenOptions: {},
    };

    /* VIEWED & FAVOURITE PLANS */
    this.viewedPlans = {
      keyMap: {},
      list: [],
    };

    this.favouritePlans = {
      keyMap: {},
      list: [],
    };

    /* PAGINATION */
    this.pagination = {
      offset: 0,
      limit: this.appConfig.plan.searchPageLimits,
      totalPlans: 0,
      currentPage: 1,
      hasPrev: false,
      hasNext: false,
      lastItemSeq: "-",
    };

    /* TEMP DATA */
    this.tempData.currentHistoryTab = 1;
  }

  async ngOnInit() {
    /* SET PAGE TITLE */
    this.commonService.setTitle(
      "夜行バスや高速バスの価格比較・予約サイト｜バスブックマーク"
    );

    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* CHECK IF YOU ARE WANT TO VIEW STATION MAP */
    this.checkForOpeningStationDetailModal();

    /* GET BUS SETTINGS */
    this.busSettings = this.commonService.getData(this.commonService.appConfig.site.settingSessionName);
    if(this.busSettings === null) {
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.busSettings = this.commonService.getData(this.commonService.appConfig.site.settingSessionName);
    }
    /* GET PLAN DATA */
    this.targetDay = this.initDate;
    this.hasTargetDay = false;
    this.filterData.targetDay = this.initDate;

    /* INIT SEARCH & FILTER DATA */
    this.initSearchNFilterData();

    this.monthJustChanged = true;

    /* VIEWED & FAVOURITE PLANS */
    this.getViewedPlans();
    this.getFavouritePlans();

    /* GET NOTIFY LIST */
    this.tempData.swiperInitialized = false;
    this.siteService.getNotifyList().then((res: any) => {
      this.notifyList = res;
    });

    /* GET BEST PRICES: THE FIRST TAB */
    this.getBestPrice(16, "26,7,30,31,29");

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  async checkForOpeningStationDetailModal() {
    let travelID = this.activatedRoute.snapshot.paramMap.get("travelID");
    let stationID = this.activatedRoute.snapshot.paramMap.get("stationID");

    if (stationID && stationID) {
      let stationData = await this.planService.getStation({
        travelID: travelID,
        stationID: stationID,
      });

      if (!this._.isEmpty(stationData)) {
        this.setActivatedStation(stationData);

        /* LAUNCH MODAL */
        this.$("#mdl-map").modal();
      }
    }
  }

  async initSearchNFilterData() {
    /* SEARCH PARAMS */
    this.searchParams = {
      departureYMD: this.targetDay,
      departureCityID: "",
      destinationCityID: "",
      departureTownID: "",
      destinationTownID: "",
      planOptions: "",
      offset: this.pagination.offset,
      limit: this.pagination.limit,
      sort: 1 /* 1:料金安い順 2:料金高い順 3:出発時刻早い順 4:出発時刻遅い順 省略時は1 */,
    };

    /* GET SAVED FILTER DATA */
    let savedFilterData = this.planService.getFilterOptions();
    if (!this._.isEmpty(savedFilterData)) {
      if (
        !this.hasTargetDay &&
        this.moment(savedFilterData.departureYMD).valueOf() >
          this.moment(this.targetDay).valueOf()
      ) {
        this.targetDay = savedFilterData.departureYMD;
        this.searchParams.departureYMD = this.targetDay;
        this.filterData.targetDay = this.targetDay;
      }

      this.searchParams.departureCityID = savedFilterData.departureCityID;
      this.searchParams.destinationCityID = savedFilterData.destinationCityID;
      this.searchParams.departureTownID = savedFilterData.departureTownID;
      this.searchParams.destinationTownID = savedFilterData.destinationTownID;
      this.searchParams.planOptions = savedFilterData.planOptions;
      this.searchParams.sort = savedFilterData.sort;

      this.filterData.chosenOptions = savedFilterData.chosenOptions;
      this.filterData.townData = savedFilterData.townData;
    }

    /* GET DIVISION DATA */
    this.filterData.divisionData = await this.planService.getDivisions();
    /* END */

    /* SET CITY & TOWN DATA FROM URL PARAM */
    /* CITY */
    if (!this._.isEmpty(this.city)) {
      let cityArr = this.city.split("_");
      if (cityArr.length === 1) {
        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[0]}`
          )
        ) {
          this.searchParams.departureCityID =
            this.filterData.divisionData.division_map.slug[cityArr[0]].id_bb;
          this.searchParams.destinationCityID = "";
        } else {
          this.searchParams.departureCityID = "";
          this.searchParams.destinationCityID = "";
        }
      } else if (cityArr.length > 1) {
        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[0]}`
          )
        ) {
          this.searchParams.departureCityID =
            this.filterData.divisionData.division_map.slug[cityArr[0]].id_bb;
        } else {
          this.searchParams.departureCityID = "";
        }

        if (
          this._.has(
            this.filterData.divisionData,
            `division_map.slug.${cityArr[1]}`
          )
        ) {
          this.searchParams.destinationCityID =
            this.filterData.divisionData.division_map.slug[cityArr[1]].id_bb;
        } else {
          this.searchParams.destinationCityID = "";
        }
      }
    }

    /* TOWN */
    if (!this._.isEmpty(this.town)) {
      let townArr = this.town.split("_");
      if (townArr.length === 1) {
        this.filterData.cityChoosingType = "departure";
        await this.getTowns(this.searchParams.departureCityID);
        if (
          this._.has(
            this.filterData.townData,
            `departure.map.slug.${townArr[0]}`
          )
        ) {
          this.searchParams.departureTownID =
            this.filterData.townData.departure.map.slug[townArr[0]].id;
          this.searchParams.destinationTownID = "";
        } else {
          this.searchParams.departureTownID = "";
          this.searchParams.destinationTownID = "";
        }
      } else if (townArr.length > 1) {
        this.filterData.cityChoosingType = "departure";
        await this.getTowns(this.searchParams.departureCityID);
        this.filterData.cityChoosingType = "destination";
        await this.getTowns(this.searchParams.destinationCityID);
        if (
          this._.has(
            this.filterData.townData,
            `departure.map.slug.${townArr[0]}`
          )
        ) {
          this.searchParams.departureTownID =
            this.filterData.townData.departure.map.slug[townArr[0]].id;
        } else {
          this.searchParams.departureTownID = "";
        }

        if (
          this._.has(
            this.filterData.townData,
            `destination.map.slug.${townArr[1]}`
          )
        ) {
          this.searchParams.destinationTownID =
            this.filterData.townData.destination.map.slug[townArr[1]].id;
        } else {
          this.searchParams.destinationTownID = "";
        }
      }
    } else if (!this._.isEmpty(this.city)) {
      this.searchParams.departureTownID = "";
      this.searchParams.destinationTownID = "";
    }
    /* END */

    /* SET FILTER DATA */
    this.filterData.departureYMD = this.searchParams.departureYMD;
    this.filterData.departureCityID = this.searchParams.departureCityID;
    this.filterData.destinationCityID = this.searchParams.destinationCityID;
    this.filterData.departureTownID = this.searchParams.departureTownID;
    this.filterData.destinationTownID = this.searchParams.destinationTownID;
    this.filterData.sort = this.searchParams.sort;
    /* END */
  }

  /* FILTER */
  changeCity(id: any, type: any) {
    if (type == "departure") {
      this.filterData.departureCityID = id;
      this.filterData.departureTownID = "";
      /* CHANGE TO NEXT TAB */
      this.filterData.cityChoosingType = "destination";
      this.filterData.isViewingCalendar = false;
    } else {
      this.filterData.destinationCityID = id;
      this.filterData.destinationTownID = "";
      /* CHANGE TO NEXT TAB */
      this.filterData.cityChoosingType = "calendar";
      this.filterData.isViewingCalendar = false;
      this.getFilterCalendarPrices();
    }
  }

  getCityName(id: any, type: any = null) {
    if (this._.has(this.filterData.divisionData, `division_map.id_bb.${id}`)) {
      return this.filterData.divisionData.division_map.id_bb[id].name;
    }

    if (this._.isEmpty(type)) {
      return "---";
    }

    if (type == "departure") {
      return "出発地を選択";
    }
    return "到着地を選択";
  }

  getTownName(id: any, type: any) {
    if (type == "departure") {
      if (this._.has(this.filterData.townData.departure, `map.id_bb.${id}`)) {
        return this.filterData.townData.departure.map.id_bb[id].name;
      }
    } else {
      if (this._.has(this.filterData.townData.destination, `map.id_bb.${id}`)) {
        return this.filterData.townData.destination.map.id_bb[id].name;
      }
    }
    return "---";
  }

  async getTowns(cityID: any) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");
    let townData: any = await this.planService.getTowns(cityID);
    if (this.filterData.cityChoosingType == "departure") {
      this.filterData.townData.departure = townData;

      /* CHOOSE FIRST IF EMPTY */
      if (this.filterData.departureTownID == "") {
        this.filterData.departureTownID =
          this.filterData.townData.departure.list[0].id;
      }
    } else {
      /* DESTINATION */
      this.filterData.townData.destination = townData;

      /* CHOOSE FIRST IF EMPTY */
      if (this.filterData.destinationTownID == "") {
        this.filterData.destinationTownID =
          this.filterData.townData.destination.list[0].id;
      }
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  checkActiveDivisionChildren(parent: any, isFirst: boolean = false) {
    /* IF departureCityID OR destinationCityID IS EMPTY THEN EXPANDING THE FIRST CARD */
    if (isFirst) {
      return true;
    }

    let returnData = false;
    if (parent && this.filterData.divisionData.division[parent]) {
      for (let item of this.filterData.divisionData.division[parent]) {
        if (
          (this.filterData.cityChoosingType == "departure" &&
            item.id_bb == this.filterData.departureCityID) ||
          (this.filterData.cityChoosingType == "destination" &&
            item.id_bb == this.filterData.destinationCityID)
        ) {
          returnData = true;
          break;
        }
      }
    }
    return returnData;
  }

  checkActivePlanOptions(index: number, heading: any) {
    if (this._.has(this.filterData.chosenOptions, `${heading}.${index}`)) {
      return true;
    }
    return false;
  }

  setPlanOptions(index: number, heading: any, code: any) {
    if (!this.filterData.chosenOptions.hasOwnProperty(heading)) {
      this.filterData.chosenOptions[heading] = {};
      this.filterData.chosenOptions[heading][index] = code;
    } else {
      if (this.filterData.chosenOptions[heading].hasOwnProperty(index)) {
        delete this.filterData.chosenOptions[heading][index];
      } else {
        this.filterData.chosenOptions[heading][index] = code;
      }
    }
  }

  getChosenPlanOptions() {
    let options = [];
    for (let heading in this.filterData.chosenOptions) {
      for (let option in this.filterData.chosenOptions[heading]) {
        options.push(this.filterData.chosenOptions[heading][option]);
      }
    }
    return this._.uniq(options).join("|");
  }

  chooseOnlyOneBusType(code) {
    for (const heading of this.filterData.planOptions.headings) {
      for (const [index, value] of this.filterData.planOptions.options[
        heading
      ].entries()) {
        if (
          ["10101", "10102", "10104", "10105", "10306"].includes(value.code)
        ) {
          if (this.checkActivePlanOptions(index, heading)) {
            this.setPlanOptions(index, heading, value.code);
          }
        }
        if (value.code == code) {
          this.setPlanOptions(index, heading, code);
        }
      }
    }
  }

  /* OPEN FILTER */
  openFilter() {
    let departureYMD = this.searchParams.departureYMD;
    this.filterData.departureYMD = departureYMD;
    this.tempData.filterTargetDay = this.filterData.targetDay;

    /* PLAN OPTIONS */
    this.filterData.tempChosenOptions = JSON.parse(
      JSON.stringify(this.filterData.chosenOptions)
    );
  }

  /* APPLY FILTER */
  async applyFilter() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET FILTER DATA */
    this.filterData.departureYMD = this.moment(
      this.filterData.targetDay
    ).format("YYYYMMDD");

    this.searchParams.departureYMD = this.filterData.departureYMD;
    this.searchParams.departureCityID = this.filterData.departureCityID;
    this.searchParams.destinationCityID = this.filterData.destinationCityID;
    this.searchParams.departureTownID = this.filterData.departureTownID;
    this.searchParams.destinationTownID = this.filterData.destinationTownID;

    this.filterData.tempChosenOptions = this.filterData.chosenOptions;
    /* END */

    /* SET DATA FOR GETTING LIST */
    this.pagination.currentPage = 1; /* BACK TO THE FIRST PAGE */
    this.targetDay = this.searchParams.departureYMD;
    this.hasTargetDay = true;
    this.monthJustChanged = true;

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  doSearch(clearOptions: boolean = false) {
    /* CHECK IF OPTIONS DISCARDED */
    if (clearOptions) {
      this.filterData.chosenOptions = {};
    }

    /* APPLY & SAVE FILTER OPTIONS */
    this.applyFilter();
    this.saveFilter();
    this.analyticsService.search("home", this.searchParams, this.filterData);

    return this.updateURL(
      {
        date: this.searchParams.departureYMD,
      },
      true
    );
  }

  /* CANCEL FILTER */
  async cancelFilter() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* SET FILTER DATA */
    this.targetDay = this.filterData.departureYMD;
    this.searchParams.departureYMD = this.filterData.departureYMD;

    this.filterData.targetDay = this.tempData.filterTargetDay;
    this.filterData.departureCityID = this.searchParams.departureCityID;
    this.filterData.destinationCityID = this.searchParams.destinationCityID;
    this.filterData.departureTownID = this.searchParams.departureTownID;
    this.filterData.destinationTownID = this.searchParams.destinationTownID;

    this.filterData.chosenOptions = this.filterData.tempChosenOptions;
    /* END */

    /* await this.getPlanList(); */

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  reverseDivisions(forceChange: boolean = false) {
    let valData = {
      departureCityID: this.filterData.departureCityID,
      destinationCityID: this.filterData.destinationCityID,
      departureTownID: this.filterData.departureTownID,
      destinationTownID: this.filterData.destinationTownID,

      townData: {
        departure: this.filterData.townData.departure,
        destination: this.filterData.townData.destination,
      },
    };

    this.filterData.departureCityID = valData.destinationCityID;
    this.filterData.destinationCityID = valData.departureCityID;
    this.filterData.departureTownID = valData.destinationTownID;
    this.filterData.destinationTownID = valData.departureTownID;

    this.filterData.townData.departure = valData.townData.destination;
    this.filterData.townData.destination = valData.townData.departure;

    if (forceChange === true) {
      this.searchParams.departureCityID = valData.destinationCityID;
      this.searchParams.destinationCityID = valData.departureCityID;
      this.searchParams.departureTownID = valData.destinationTownID;
      this.searchParams.destinationTownID = valData.departureTownID;

      /* APPLY FILTER OPTIONS */
      this.applyFilter();
    }
  }

  onFilterDateChanged(data: any) {
    this.filterData.targetDay = data.date;
  }

  saveFilter() {
    this.planService.saveFilterOptions({
      departureYMD: this.searchParams.departureYMD,
      departureCityID: this.searchParams.departureCityID,
      destinationCityID: this.searchParams.destinationCityID,
      departureTownID: this.searchParams.departureTownID,
      destinationTownID: this.searchParams.destinationTownID,
      planOptions: this.searchParams.planOptions,
      sort: this.searchParams.sort,
      chosenOptions: this.filterData.chosenOptions,
      townData: this.filterData.townData,
    });

    /* SAVE CACHE */
    this.cacheService.setData(
      this.appConfig.plan.divisionDataSessionName,
      this.filterData.divisionData
    );
  }
  /* END */

  async getPlanList() {
    this.pagination.totalPlans = 0;
    this.pagination.lastItemSeq = "-";
    this.pagination.offset =
      (this.pagination.currentPage - 1) * this.pagination.limit;
    this.searchParams.offset = this.pagination.offset;
    this.searchParams.planOptions = this.getChosenPlanOptions();

    /* GET PLAN LIST */
    let data = await this.planService.getPlanList(this.searchParams);
    this.planList = data.list;
    this.pagination.totalPlans = data.totalPlans;
  }

  /* HISTORY */
  getViewedPlans(event: any = {}) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    let data = this.planService.getViewedPlans();
    if (data) {
      this.viewedPlans = data;
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  async getBestPrice(departureID: any, destinationIDs: any) {
    if (departureID && destinationIDs) {
      this.tempData.bestPriceLoading = true;

      let currentMonth = this.moment().format("YYYYMM");
      let nextMonth = this.moment().add(1, "month").format("YYYYMM");

      this.bestPriceData = {};

      this.planService.getBestPrice(
        {
          departureYMs: `${currentMonth},${nextMonth}`,
          departureID: departureID,
          destinationIDs: destinationIDs,
        },
        (bestPriceData: any) => {
          if (!this._.isEmpty(bestPriceData)) {
            let destinationArr = String(destinationIDs).split(",");

            this.bestPriceData = {
              currentMonth: this.moment(currentMonth, "YYYYMM").format("M"),
              nextMonth: this.moment(nextMonth, "YYYYMM").format("M"),
              data: [],
            };

            for (let destinationID of destinationArr) {
              try {
                this.bestPriceData.data.push({
                  name: `${this.filterData.divisionData.division_map.id_bb[departureID].name}→${this.filterData.divisionData.division_map.id_bb[destinationID].name}`,
                  link: `${this.commonService.routePaths.pagePlanListNoParam}/${
                    this.filterData.divisionData.division_map.id_bb[departureID]
                      .slug
                  }_${
                    this.filterData.divisionData.division_map.id_bb[
                      destinationID
                    ].slug
                  }/${this.moment(
                    bestPriceData[currentMonth][destinationID].day
                  ).format("YYYYMMDD")}`,
                  price1:
                    bestPriceData[currentMonth] &&
                    bestPriceData[currentMonth][destinationID] &&
                    bestPriceData[currentMonth][destinationID].best_price
                      ? `${this.commonService.formatCurrency(
                          bestPriceData[currentMonth][destinationID].best_price
                        )}円`
                      : "-",
                  price2:
                    bestPriceData[nextMonth] &&
                    bestPriceData[nextMonth][destinationID] &&
                    bestPriceData[nextMonth][destinationID].best_price
                      ? `${this.commonService.formatCurrency(
                          bestPriceData[nextMonth][destinationID].best_price
                        )}円`
                      : "-",
                });
              } catch (err) {
                /* DO NOTHING */
                console.log(err);
              }
            }
          }

          this.tempData.bestPriceLoading = false;
        }
      );
    }
  }

  /* FAVORITE */
  getFavouritePlans(event: any = {}) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    let data = this.planService.getFavouritePlans();
    if (data) {
      this.favouritePlans = data;
    }

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  /* BELONGS TO CALENDAR */
  async getFilterCalendarPrices() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* THIS MONTH */
    let searchParams = {
      departureYMD: this.calendarDate,
      departureCityID: this.filterData.departureCityID,
      destinationCityID: this.filterData.destinationCityID,
      departureTownID: this.filterData.departureTownID,
      destinationTownID: this.filterData.destinationTownID,
      planOptions: this.getChosenPlanOptions(),
      sort: 1,
      offset: 0,
      limit: 1,
    };

    let thisMonth = searchParams.departureYMD;

    let searchParamsNextMonth = JSON.parse(JSON.stringify(searchParams));
    searchParamsNextMonth.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(1, "months")
      .format("YYYYMMDD");

    let searchParamsNext2Month = JSON.parse(JSON.stringify(searchParams));
    searchParamsNext2Month.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(2, "months")
      .format("YYYYMMDD");

    let searchParamsNext3Month = JSON.parse(JSON.stringify(searchParams));
    searchParamsNext3Month.departureYMD = this.moment(thisMonth, "YYYYMM")
      .add(3, "months")
      .format("YYYYMMDD");

    Promise.all([
      this.planService.getPlanList(searchParams),
      this.planService.getPlanList(searchParamsNextMonth),
      this.planService.getPlanList(searchParamsNext2Month),
      this.planService.getPlanList(searchParamsNext3Month),
    ]).then((data) => {
      this.filterData.bestPriceList.thisMonth = data[0].price_calendar;
      this.filterData.bestPriceList.nextMonth = data[1].price_calendar;
      this.filterData.bestPriceList.next2Month = data[2].price_calendar;
      this.filterData.bestPriceList.next3Month = data[3].price_calendar;

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    });
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  updateURL(data: any, redirect: boolean = false) {
    let route = ``;

    /* CITY */
    if (
      this.searchParams.departureCityID != "" ||
      this.searchParams.destinationCityID != ""
    ) {
      route +=
        this.searchParams.departureCityID != ""
          ? `${
              this.filterData.divisionData.division_map.id_bb[
                this.searchParams.departureCityID
              ].slug
            }_`
          : `_`;
      route +=
        this.searchParams.destinationCityID != ""
          ? `${
              this.filterData.divisionData.division_map.id_bb[
                this.searchParams.destinationCityID
              ].slug
            }/`
          : `/`;
    }

    /* TOWN */
    if (
      this.searchParams.departureTownID != "" ||
      this.searchParams.destinationTownID != ""
    ) {
      route +=
        this.searchParams.departureTownID != ""
          ? `${
              this.filterData.townData.departure.map.id_bb[
                this.searchParams.departureTownID
              ].slug
            }_`
          : `_`;
      route +=
        this.searchParams.destinationTownID != ""
          ? `${
              this.filterData.townData.destination.map.id_bb[
                this.searchParams.destinationTownID
              ].slug
            }/`
          : `/`;
    }

    /* DATE */
    route += `${this.moment(data.date).format("YYYYMMDD")}`;

    if (redirect) {
      return this.commonService.redirectToRoute(
        `${this.commonService.routePaths.pagePlanListNoParam}/${route}`
      );
    } else {
      this.location.replaceState(
        `${this.commonService.routePaths.pagePlanListNoParam}/${route}`
      );
    }
  }
  /* END */

  /* CHILDREN */
  footerMenuClick(data: any) {
    switch (data.event) {
      case "search":
        this.filterData.isViewingCalendar = true;
        this.openFilter();
        break;
    }
  }

  inlineJS() {
    let self = this;

    /* NOTIFY LIST CLICK :: WORKAROUND FOR SWIPER */
    this.$(document).on("click", "#top-info a", function () {
      let index = self.$(this).attr("data-index");
      if (typeof self.notifyList[index] !== "undefined") {
        self.notifyDetail = self.notifyList[index];
        if(!self.ref['destroyed']) {
          self.ref.detectChanges();
        }

        self.$("#mdl-info").modal();
      }
    });

    /* CHECK PARENT MODAL IS STILL OPENED */
    self.$(document).on("hidden.bs.modal", ".modal", function () {
      if (self.$(".modal.show").length != 0) {
        self.$("body").addClass("modal-open");
      }
    });
    /* END */
  }

  initSwiper() {
    this.tempData.swiperInitialized = true;
    let self = this;

    /* INIT NOTIFY SLIDER AFTER SECONDS (WORKAROUND FOR DYNAMIC CONTENT) */
    setTimeout(function () {
      self.$(".swiper-container").each(function () {
        if (self.$(this).find(".swiper-slide").length > 1) {
          new Swiper(self.$(this), {
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              type: "bullets",
              clickable: true,
            },
            autoplay: {
              delay: 3000,
              disableOnInteraction: true,
            },
            autoHeight: true,
          });
        }
      });
    }, 1500); /* 0.5 SECOND */

    return false;
  }
}
